import React from 'react'
import Profile1 from './assets/Staff/profile-pic-1.png'

import { IEventStaffInterfaceTypes as iesit } from '../../../../models/event-staff/event-staff.interface'

import { CONST } from '../../../../const/const'
import { Link } from 'react-router-dom'
import { useAppSelector } from '../../../../store/hooks'
import { selectUserId } from '../../../../store/user/userSlice'

const generateName = (fullName: string | undefined) => {
  return fullName
    ? fullName
        .split(' ')
        .map((name) => name[0])
        .join('')
        .toUpperCase()
    : ''
}

const EventDetailViewComponentProfileCart_: React.FC<{
  name: string
  title: string
  staffId: string
  picture: string
  userId: string | null
}> = ({ picture, title, name, staffId, userId }) => (
  <Link
    to={
      staffId === userId
        ? CONST.ROUTES.USER_PROFILE.URL
        : `${CONST.ROUTES.USER_PROFILE.URL}/${staffId}`
    }
  >
    <div className="flex gap-2 ml-[-30px] md:ml-0">
      <div className="flex items-center shrink-0 rounded-full">
        <img
          src={picture}
          alt="profile"
          className="rounded-full h-[30px] 2xl:h-[45px] w-[30px] 2xl:w-[45px] object-cover shrink-0"
          onError={(e) =>
            ((e.target as any).src =
              `https://ui-avatars.com/api/?name=${generateName(name ?? '')}&background=FFFFFF&format=svg&bold=true&color=BCC6D5&rounded=true`)
          }
        />
      </div>
      <div className="flex-col hidden md:flex w-[160px]">
        <span className="whitespace-nowrap text-ellipsis text-sm 2xl:text-nr text-SeabiscuitDark200ThemeColor text-opacity-[.5] overflow-hidden">
          {title}
        </span>
        <div className="text-nr 2xl:text-base text-SeabiscuitDark200ThemeColor text-opacity-[.84] ellipsis capitalize">
          {name}
        </div>
      </div>
    </div>
  </Link>
)

const EventDetailViewComponentStaffSection: React.FC<{
  staffData?: any
  eventStaffData?: iesit['IStaffUiListItem'][]
}> = (props) => {
  const userId = useAppSelector(selectUserId)
  const DEFAULT_ICON_FOR_STAFF_CATEGORY = 'assets/og_icons/PeopleB.svg'

  return (
    <>
      {props?.eventStaffData && props?.eventStaffData?.length ? (
        props?.eventStaffData?.map((staffUiItem) => {
          return staffUiItem?.staffs?.length ? (
            <div className="grid grid-cols-1 gap-4 mb-4" key={JSON.stringify(staffUiItem)}>
              <div className="flex flex-wrap items-center md:block border-[1px] border-[#D3DAEE] border-solid rounded-xl py-4 px-4 md:px-6 2xl:px-[30px]">
                <div className="flex gap-2 items-center md:mb-4 flex-1">
                  <img
                    src={staffUiItem?.icon ? staffUiItem?.icon : DEFAULT_ICON_FOR_STAFF_CATEGORY}
                    className="w-6 h-6"
                    alt={staffUiItem?.category}
                  />
                  <div className="text-SeabiscuitDark200ThemeColor font-bold text-nr 2xl:text-base capitalize">
                    {staffUiItem?.category}
                  </div>
                </div>

                <div className="flex ml-auto md:gap-x-[10px] md:gap-y-6 flex-wrap">
                  {staffUiItem?.staffs && staffUiItem?.staffs?.length
                    ? staffUiItem?.staffs?.map((staff, index) => {
                        if (typeof staff !== 'string' && 'staffName' in staff) {
                          return (
                            // eslint-disable-next-line react/jsx-pascal-case
                            <EventDetailViewComponentProfileCart_
                              userId={userId}
                              name={staff?.staffName}
                              staffId={staff?.staffId}
                              title={staff?.staffType}
                              key={JSON.stringify({ staff, index })}
                              picture={staff?.staffProfilePicture ?? Profile1}
                            />
                          )
                        }

                        return null
                      })
                    : null}
                </div>
              </div>
            </div>
          ) : (
            ''
          )
        })
      ) : (
        <div className="text-sm 2xl:text-nr text-SeabiscuitDark200ThemeColor">
          No staff have been added to this event
        </div>
      )}

      {/* <EventDetailViewComponentStaffSectionManagement /> */}
      {/* <EventDetailViewComponentStaffSectionJudges allStaffsModal={allStaffsModal}/>
            <EventDetailViewComponentStaffSectionStewards allStaffsModal={allStaffsModal}/>
            <EventDetailViewComponentStaffSectionVeterinarians allStaffsModal={allStaffsModal}/>
            <EventDetailViewComponentStaffSectionVolunteers allStaffsModal={allStaffsModal}/> */}
    </>
  )
}

export default EventDetailViewComponentStaffSection
